import { render, staticRenderFns } from "./AffiliateSignatureText.vue?vue&type=template&id=b3287e0e"
import script from "./AffiliateSignatureText.vue?vue&type=script&lang=ts"
export * from "./AffiliateSignatureText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports